function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M28.5 10.92v-4.5h3v7a.5.5 0 0 1-.5.5H20a.5.5 0 0 1-.5-.5v-7h3v4.5h6zm3 15a1.5 1.5 0 0 1 0-3h3a1.5 1.5 0 0 1 0 3h-3zm-15 12a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zm0 3c-5.799 0-10.5-4.7-10.5-10.5 0-5.799 4.701-10.5 10.5-10.5S27 24.621 27 30.42c0 5.8-4.701 10.5-10.5 10.5zm8.988-8.859v-3H37.49a1.5 1.5 0 0 0 1.5-1.5V9.5a1.5 1.5 0 0 0-1.5-1.5H13.468a1.5 1.5 0 0 0-1.5 1.5v13.874h-3V9.5a4.5 4.5 0 0 1 4.5-4.5H37.49a4.5 4.5 0 0 1 4.5 4.5v18.061a4.5 4.5 0 0 1-4.5 4.5H25.488zm-6.949-4.396c.395-.525.22-1.225-.392-1.564-.61-.339-1.426-.188-1.82.337l-2.613 3.477a.5.5 0 0 0-.016.58l2.595 3.86c.363.54 1.169.726 1.798.413.63-.312.846-1.004.482-1.545l-1.988-2.958 1.954-2.6zm4.795 10.255a1.5 1.5 0 1 1 0-3H40.5a1.5 1.5 0 0 1 0 3H23.334zm-.834 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm9 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm9 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
});

var SvgHubBack = function SvgHubBack(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgHubBack;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/hub-back.svg
// module id = 148
// module chunks = 0 1